import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEn from "./locales/en/translation.json";
import translationEs from "./locales/es/translation.json";
import translationFr from "./locales/fr/translation.json";
import translationDe from "./locales/de/translation.json";
import translationJa from "./locales/ja/translation.json";
import translationPl from "./locales/pl/translation.json";
import translationPt from "./locales/pt/translation.json";

i18n
  .use(initReactI18next)
  .init({
    debug: false,

    fallbackLng: "en",

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      es: {
        translations: translationEs,
      },
      fr: {
        translations: translationFr,
      },
      de: {
        translations: translationDe,
      },
      ja: {
        translations: translationJa,
      },
      pl: {
        translations: translationPl,
      },
      pt: {
        translations: translationPt,
      },
    },

    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;
